import { ISpritesheetMetadata } from '../../types/types';

// Manual (non-generated) UI face portraits for dialogue boxes. Each is a
// single-frame PNG under public/sprites/ui/faces/; the frame key IS the
// `portraitId` passed to <Icon> (cf. DialogueScreen).
export const FacesSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'face-pan-pan',
    metadata: {
      frames: {
        'face-pan-pan': {
          frame: { x: 0, y: 0, w: 40, h: 40 },
          sourceSize: { w: 40, h: 40 },
          spriteSourceSize: { x: 0, y: 0, w: 40, h: 40 },
        },
      },
      meta: {
        image: '/sprites/ui/faces/ryan.png',
        size: { w: 40, h: 40 },
        scale: '1',
      },
      animations: { 'face-pan-pan': ['face-pan-pan'] },
    },
  },
];
